module.exports = __webpack_public_path__ + "img/esim_area_zh-cn.44b7c55f.png";